import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/deviceStructure/deviceParts.scss";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import {
  multifunctionOption,
  riceMillOption,
  longTailOption,
  agricutureOption,
} from "assets/data/sparePartsModel";
import DeviceModelPartsModal from "components/modals/deviceModelPartsModal";
import multifunction from "assets/data/spareParts/multifunction.json";
import long_tail from "assets/data/spareParts/longTail.json";
import agricuture from "assets/data/spareParts/agricuture.json";
import riceMill from "assets/data/spareParts/riceMill.json";
import AlertModal from "components/modals/alertModal";
import Swal from "sweetalert2";

export default class DeviceParts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      searchModel: null,
      devicesList: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      modelModal: false,
      model: {},
      isAlert: false,
      alertText: "",
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  onChangeAlert = (text) => {
    this.setState({ isAlert: !this.state.isAlert, alertText: text });
  };

  async componentDidMount() {
    this.startLoading();
    await this.setPartsData({ model: null });
    this.stopLoading();
  }

  setModelModal = (model) => {
    this.setState({
      modelModal: !this.state.modelModal,
    });
    this.setShowData(model);
  };

  setShowData = (data) => {
    let spareDetail = null;
    if (data === undefined) {
      return;
    }
    if (data.model === "multifunction") {
      spareDetail = multifunction.filter((spare) => spare.name === data.name);
      if (spareDetail != null) {
        this.setState({ model: spareDetail[0] });
      }
    } else if (data.model === "long_tail") {
      spareDetail = long_tail.filter((spare) => spare.name === data.name);
      if (spareDetail != null) {
        this.setState({ model: spareDetail[0] });
      }
    } else if (data.model === "agricuture") {
      spareDetail = agricuture.filter((spare) => spare.name === data.name);
      if (spareDetail != null) {
        this.setState({ model: spareDetail[0] });
      }
    } else if (data.model === "riceMill") {
      spareDetail = riceMill.filter((spare) => spare.name === data.name);
      if (spareDetail != null) {
        this.setState({ model: spareDetail[0] });
      }
    }
  };

  setPartsData = async (data) => {
    const { getMasterParts } = this.context;
    await getMasterParts(data);

    const filteredPartsList = this.context.partsList.filter(device => device.is_delete === 0);
    this.setState({
      devicesList: filteredPartsList.slice(this.state.begin, this.state.end),
    });
  };

  confirmAction = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  deleteDevicePart = async (code) => {
    const { deleteParts } = this.context;
    const data = {
      code: code,
    };

    // แสดงข้อความยืนยันการลบ
    const confirmDelete = await this.confirmAction("คุณต้องการลบข้อมูลอะไหล่เครื่องจักร " + code + " ใช่หรือไม่?");
    if (!confirmDelete) {
      return; // ไม่ทำอะไรเมื่อผู้ใช้ยกเลิกการลบ
    }

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    // statusForm = "delete";
    console.log("datadelete", data);
    
    let result = await deleteParts(data);
    if (result?.result === "success") {  
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    });
  };


  onUpdateParts = async (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    formData.append("operation", "parts");

    let result = await this.context.importMasterParts(formData);
    console.log("result: " + result);
    if (result != null) {
      this.onChangeAlert(result);
      this.context.importMasterParts({ model: "" });
    } else {
      this.onChangeAlert(result);
    }
  };

  createDeviceSearch = () => {
    const { partsList } = this.context;
    const { searchModel } = this.state;
    const iotOptions = partsList?.map((device) => ({
      key: device.code,
      value: device.code,
      text: device.name_th,
    }));
    return (
      <div className="search">
        <Form>
          <b>อะไหล่เครื่องจักร</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={iotOptions}
              value={searchModel}
              placeholder="อะไหล่เครื่องจักร"
              search
              onChange={(e, { value }) => this.setState({ searchModel: value })}
            />
            <Button
              onClick={() => {
                this.setPartsData({ model: null });
                this.setState({
                  searchModel: null,
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setPartsData({ partCode: searchModel });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
            &ensp;
            <input
              ref="fileInput"
              onChange={this.onUpdateParts}
              type="file"
              style={{ display: "none" }}
              multiple={false}
            />
            <Button color="twitter" onClick={() => this.refs.fileInput.click()}>
              <Icon name="upload" />
              อัพโหลดอะไหล่เครื่องจักร
            </Button>
          </Form.Group>
          <Form.Group inline>
            
          </Form.Group>
        </Form>
      </div>
    );
  };

  createShowModel = () => {
    return (
      <div className="model">
        <div className="model-multifunction">
          <h3>
            <Icon name="code branch" />
            SPARE PART MULTIFUNCTION
          </h3>
          <ul>
            {multifunctionOption.map((model, idx) => (
              <li
                key={idx}
                onClick={() =>
                  this.setModelModal({
                    model: "multifunction",
                    name: model,
                  })
                }
              >
                {model}
              </li>
            ))}
          </ul>
        </div>
        <div className="model-rice">
          <h3>
            <Icon name="code branch" />
            SPARE PART RICE MILL
          </h3>
          <ul>
            {riceMillOption.map((model, idx) => (
              <li
                key={idx}
                onClick={() =>
                  this.setModelModal({
                    model: "riceMill",
                    name: model,
                  })
                }
              >
                {model}
              </li>
            ))}
          </ul>
        </div>
        <div className="model-tail">
          <h3>
            <Icon name="code branch" />
            SPARE PART LONG TAIL
          </h3>
          <ul>
            {longTailOption.map((model, idx) => (
              <li
                key={idx}
                onClick={() =>
                  this.setModelModal({
                    model: "long_tail",
                    name: model,
                  })
                }
              >
                {model}
              </li>
            ))}
          </ul>
        </div>
        <div className="model-agricuture">
          <h3>
            <Icon name="code branch" />
            SPARE PART AGRICUTURE
          </h3>
          <ul>
            {agricutureOption.map((model, idx) => (
              <li
                key={idx}
                onClick={() =>
                  this.setModelModal({
                    model: "agricuture",
                    name: model,
                  })
                }
              >
                {model}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  createDataTable = () => {
    const { devicesList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>รหัสอะไหล่ (Item Code)</Table.HeaderCell>
            <Table.HeaderCell>ชื่ออะไหล่</Table.HeaderCell>
            <Table.HeaderCell>ราคาอะไหล่ (บาท)</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {devicesList?.map((device, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{device.code}</Table.Cell>
              <Table.Cell>{device.name_th}</Table.Cell>
              <Table.Cell>{device?.price.toLocaleString()}</Table.Cell>
              <Table.Cell>
                <Button  
                  className="action-btn"
                  style={{
                    fontFamily: "Kanit",
                    fontSize: "16px",
                    backgroundColor: "#ff6347",
                  }} 
                    onClick={() => this.deleteDevicePart(device.code)}>      
                  ลบข้อมูล
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { partsList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      devicesList: [...partsList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const {
      isLoading,
      activePage,
      pageSize,
      modelModal,
      model,
      isAlert,
      alertText,
    } = this.state;
    return (
      <div className="deviceParts">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="iotDevice" categories="deviceParts" />
        <Navigation />

        <AlertModal
          isOpen={isAlert}
          text={alertText}
          isClose={this.onChangeAlert}
        />

        <DeviceModelPartsModal
          isOpen={modelModal}
          isClose={this.setModelModal}
          data={model}
        />

        <div className="deviceParts-content">
          <h2>อะไหล่เครื่องจักร</h2>
          <hr />

          <div className="deviceParts-content-search">
            {this.createDeviceSearch()}
          </div>
          <hr />

          <div className="deviceParts-content-model">
            {this.createShowModel()}
          </div>

          <hr />
          <div className="deviceParts-content-table">
            {this.createDataTable()}
          </div>
          <div className="deviceParts-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(this.context.partsList?.length / pageSize)}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

DeviceParts.contextType = DeviceContext;
